import { Metamodel } from '../base/model';
import { AzurePostgreSqlTableDataset } from 'app/model/dataset/azure-postgre-sql-table.dataset';
import { AzureHorizonDBLinkedService } from 'app/model/linkedservice/azure-horizon-db.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

/**
 * Azure HorizonDB is PostgreSQL wire-compatible, so its dataset shares the exact same shape as
 * the Azure Database for PostgreSQL table dataset. It is modeled as its own dataset type
 * ('AzureHorizonDBTable'), bound to the AzureHorizonDB linked service, and inherits all
 * attributes/behaviors from AzurePostgreSqlTableDataset.
 */
@Metamodel.model({
    name: adfModelTypeMap.azureHorizonDb.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.AzureHorizonDB_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.AzureHorizonDB_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: AzureHorizonDBLinkedService.MODEL // Linked service redefined
        }
    }
})
export class AzureHorizonDBTableDataset extends AzurePostgreSqlTableDataset {
    // HorizonDB is newly introduced and has no driver-version concept. In Fabric the driver version
    // normally lives on the copy activity source/sink settings and is echoed into the query API
    // (preview / schema / test-connection). HorizonDB must never carry or emit a version, so the
    // dataset `version` is left unset. It still uses the modern connection code path (command-based
    // schema enumeration, etc.), so `shouldHonorConnectionVersion` stays true regardless of version.
    public override version: string = undefined;

    public override shouldHonorConnectionVersion(): boolean {
        return true;
    }
}
